import { configureStore } from "@reduxjs/toolkit";
import themeModeSlice from "./features/themeSlice";
import globalLoadingSlice from "./features/globalLoadingSlice";

const store = configureStore({
    reducer: {
      themeMode: themeModeSlice,
      globalLoading: globalLoadingSlice,
     
    },
  });
  
  export default store;
  